import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/phabricator': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M323 262.1c0 0 21.6 19.6 20.9 20.7l-8.1 19.8c-0.5 1.4-29.7 0.5-29.7 0.5l-9.1 9.1s1.6 31.5 0.2 32.1l-20 7.5c-1.3 0.5-21.8-23.3-21.8-23.3l-13.1-0.2s-19.3 24.1-20.7 23.5l-20.1-8.3c-1.4-0.5-1.2-32.3-1.2-32.3l-9.4-9.3s-28.9 0.9-29.5-0.5l-9.5-20c-0.6-1.4 21.1-21.2 21.1-21.2l-0.1-12.9s-21.6-19.6-21-21l8.1-19.8c0.5-1.3 29.7-0.4 29.7-0.4l9.1-9.1s-1.6-28.4-0.2-28.9l20-8.3c1.4-0.6 21.9 20.8 21.9 20.8l13.1 0.2s19.3-21.6 20.7-21l20.1 9.2c1.4 0.6 1.2 29.1 1.2 29.1l9.4 9.3s28.9-0.9 29.5 0.5l9.5 20c0.6 1.4-21.1 21.2-21.1 21.2zM278.1 253.4c-0.7-17-15.5-30.3-32.8-29.5-17.3 0.7-30.8 15.2-30.1 32.3 0.7 17.1 15.5 30.4 32.8 29.6s30.8-15.3 30.1-32.4zM479.3 215.5c22.3 22.3 22.3 58.7 0 81-67.4 67.4-44.3 44.4-95.3 95.3-74.4 74.5-194.7 74.9-269.8 1.6l-0.1 0.1c-51-51-27.5-27.6-97.4-97-22.3-22.3-22.3-58.7 0-81 67.9-67.4 44.8-44.3 95.7-95.3 74.4-74.4 194.7-74.9 269.8-1.6l0.1-0.1zM140.4 363.8c59.6 59.5 156 59.6 215.6 0.1 59.6-59.6 59.5-156.1 0-215.6-59.6-59.5-156.1-59.6-215.6 0-59.6 59.5-59.6 156 0 215.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/phabricator.js
// module id = 962
// module chunks = 0